import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import Icon1 from "../icons/Icon.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import createNewExpert from "../api/create/createNewExpert.js";
import { useSnackbar } from "notistack";
import { set } from "date-fns";
import SmallSpinner from "../loading/SmallSpinner.js";
import { Skeleton } from "@mui/material";
import { useAppContext } from "../config/AppContext.js";
import Modal1 from "../modals/Modal1.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import {
  createDoc,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import sendInvite from "../api/send/sendInvite.js";
import TextField2 from "../textfields/TextField2.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import { deleteDoc } from "firebase/firestore";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import { Player } from "@lottiefiles/react-lottie-player";
import { Spin } from "antd";
import sendAssistantRequest from "../api/send/sendAssistantRequest.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import sendAssistantBalance from "../api/send/sendAssistantBalance.js";
import { formatCentime } from "../modals/SignMarket.js";
import checkPageAccess from "../auth/checkPageAccess.js";

function Assistant({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  // State variables to store the input values

  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const [request_cost, setRequestCost] = useState(0.01);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const saved_data = appState.saved_data;
  const div_ref = React.useRef(null);

  const [tableData, setTableData] = useState(null);
  const [value, setValue] = useState("");
  const [loading_ai, setLoadingAI] = useState(false);
  const [refreshRows, setRefreshRows] = useState(false);
  const [messages, setMessages] = useState([]);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (currentUser && saved_data) {
      handleFetchData();
    }
  }, [currentUser, saved_data]);

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        // Fetch user data
        const user = await getUserById(currentUser.uid);

        if (!user.assistant_conversation_ref) {
          let body = {
            user_id: user.ref,
            messages: [],
          };
          let new_conversation = await createDocApi(
            "assistant_conversation",
            body,
            prefix
          );
          await updateDocDataFieldApi(
            user.ref,
            "assistant_conversation_ref",
            new_conversation.ref,
            prefix
          );
          user.assistant_conversation_ref = new_conversation.ref;
        } else {
          let conversation = await getDocDataByRef(
            user.assistant_conversation_ref
          );
          setMessages(conversation.messages || []);
        }
        // Fetch organization data using user's org reference
        const org = await getOrgById(user.org_id);
        const token = await getOrRefreshFirebaseToken();
        if (org.facturation?.assistant?.credits) {
          setBalance(org.facturation?.assistant?.credits);
        } else {
          await updateDocDataFieldApi(
            org.ref,
            "facturation.assistant.credits",
            10,
            prefix
          );
          setBalance(10);
        }
        // Simulate AI response

        // Update state with fetched data
        setUserData(user);
        setOrgData(org);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const scroolDown = () => {
    if (div_ref?.current) {
      div_ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleSaveConversation = async (messages) => {
    if (currentUser && userData) {
      await updateDocDataFieldApi(
        userData.assistant_conversation_ref,
        "messages",
        messages,
        prefix
      );
    }
  };

  useEffect(() => {
    if (userData !== userData) {
      scroolDown();
    }
  }, [userData]);

  useEffect(() => {
    scroolDown();

    handleSaveConversation(messages);
  }, [messages]);

  const handleSendRequest = async () => {
    if (value !== "") {
      setLoadingAI(true);

      if (balance < request_cost) {
        handleClickVariant("Crédits insuffisants", "error");
        setLoadingAI(false);
        return;
      }
      // Send request to AI model
      try {
        let new_message = {
          message: value,
          sender: "user",
          date: new Date(),
        };
        setValue("");
        setRefreshRows(!refreshRows);
        setMessages([...messages, new_message]);
        // scroll to bottom of the chat with div_ref
        const token = await getOrRefreshFirebaseToken();
        let res = await sendAssistantRequest(value, userData.id, token, prefix);
        if (res && res.success) {
          // Simulate AI response
          setLoadingAI(false);
          let extracted = extractMarkdownTables(res.message);
          let markdown_tables = extracted.tables;
          let new_text = extracted.textWithoutTables;
          let tablesData = {};
          if (markdown_tables && markdown_tables.length > 0) {
            for (let i = 0; i < markdown_tables.length; i++) {
              let markdown = markdown_tables[i];
              let tableData = parseMarkdownTable(markdown);
              tablesData[i] = tableData;
            }
          }
          let new_message2 = {
            message: new_text,
            sender: "ai",
            date: new Date(),
            tablesData: tablesData,
          };
          setMessages([...messages, new_message, new_message2]);
          await updateDocDataFieldApi(
            orgData.ref,
            "facturation.assistant.credits",
            balance - request_cost,
            prefix
          );
          setBalance(balance - request_cost);
        } else {
          setLoadingAI(false);
          handleClickVariant("Erreur lors de l'envoi de la demande", "error");
          let new_message2 = {
            message: "Désolé, je n'ai pas pu traiter votre demande",
            sender: "ai",
            date: new Date(),
          };
          setMessages([...messages, new_message, new_message2]);
        }
      } catch (error) {
        console.error("Error sending request:", error);
        setLoadingAI(false);
        handleClickVariant("Erreur lors de l'envoi de la demande", "error");
      }
    }
  };

  // make a coming soon page
  return (
    <div className="flex-row w-full h-full flex ">
      <div className="flex flex-col h-full  w-full gap-1 px-4 pt-2 pb-4">
        <div className=" text-hx2 overflow-y-auto text-shadow_25 max-h-full h-full w-full   bg-neutral-100 rounded-3xl items-center justify-center gap-2 flex flex-col">
          <div className="flex flex-col gap-2 justify-center items-center">
            {" "}
            <Icon1 icon_name="ai" size={100} fill="grey" />
            <div className="text-hx2 text-shadow_50  ">
              Bientôt disponible
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>
    </div>
  );

  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-c400 pl-4 flex flex-col gap-2">
        <Space y={20} />
        <Skeleton variant="rounded" width={200} height={25} />
        <Divider orientation="horizontal" />
        <Space y={10} />
        <div align="left" className="w-full pr-2 flex flex-col" y={10}>
          {/* Skeletons for text fields */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />

          {/* Skeletons for DatePicker and TimePicker */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />

          {/* Skeleton for dropdowns */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
        </div>

        <Space y={10} />

        {/* Skeleton for button */}
        <div className="w-full flex flex-row-reverse">
          <Skeleton variant="rectangular" width={120} height={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full flex ">
      <div className="flex flex-col h-full  w-full gap-1 px-4 pt-2 pb-4">
        <div className=" text-hx2 overflow-y-auto text-shadow_25 max-h-full h-full w-full   bg-neutral-100 rounded-3xl items-center justify-center gap-2 flex flex-col">
          {value === "" && messages?.length === 0 && (
            <div className="flex flex-col gap-2 justify-center items-center">
              {" "}
              <Icon1 icon_name="ai" size={100} fill="grey" />
              Bonjour {getFirstNameFormFullName(userData.display_name)},
              <div className="text-hx2 text-shadow_50  ">
                Comment puis-je t'aider ?
              </div>{" "}
              <div className="lg:flex hidden flex-row gap-4 mt-10">
                <div
                  onClick={() =>
                    setValue(
                      "Explique moi ce qu'est la RE2020 en 2 phrases seulement"
                    )
                  }
                  className="flex flex-col cursor-pointer hover:shadow-lg bg-white text-shadow_50 rounded-3xl text-h2 p-4 w-c200 gap-2"
                >
                  <div className="flex w-6 h-6 bg-orange-300 rounded-md items-center justify-center">
                    <Icon1 icon_name="chauffage" size={20} fill="white" />
                  </div>
                  Explique moi ce qu'est la RE2020 en 2 phrases seulement
                </div>
                <div
                  onClick={() =>
                    setValue(
                      "Quel débit atteindre en extraction dans une cuisine avec Vmc auto réglable dans un t5"
                    )
                  }
                  className="flex flex-col cursor-pointer hover:shadow-lg bg-white text-shadow_50 rounded-3xl text-h2 p-4 w-c200 gap-2"
                >
                  <div className="flex w-6 h-6 bg-blue-300 rounded-md items-center justify-center">
                    <Icon1 icon_name="question" size={20} fill="white" />
                  </div>
                  Quel débit atteindre en extraction dans une cuisine avec Vmc
                  auto réglable dans un t5
                </div>
                <div
                  onClick={() =>
                    setValue(
                      "Ecris moi un email de démarchage pour un client potentiel avec un ton professionnel"
                    )
                  }
                  className="flex flex-col cursor-pointer hover:shadow-lg bg-white text-shadow_50 rounded-3xl text-h2 p-4 w-c200 gap-2"
                >
                  <div className="flex w-6 h-6 bg-violet-300 rounded-md items-center justify-center">
                    <Icon1 icon_name="email" size={20} fill="white" />
                  </div>
                  Ecris moi un email de démarchage pour un client potentiel avec
                  un ton professionnel
                </div>
              </div>
            </div>
          )}
          {(value !== "" || messages?.length > 0) && (
            <div className=" flex  top-10  flex-col gap-3 text-h2 text-shadow_50 pb-40 max-h-full h-full max-w-full w-full p-10  ">
              <div className="flex flex-row justify-between items-start gap-4 ">
                <div className="flex flex-row min-h-fit h-fit mb-4 gap-4 items-center">
                  <Icon1 icon_name="ai" size={25} fill="grey" />
                  Conversation avec l'assistant
                </div>
                <div className="flex flex-col gap-2 items-end">
                  <div className="flex flex-row gap-4 text-h1 text-violet-500 px-3 py-0.5 rounded-full bg-purple-100">
                    {formatCentime(balance * 100)}
                  </div>
                  <div className="flex flex-row gap-4 text-h4 text--shadow_50">
                    {formatCentime(request_cost * 100)} par msg
                  </div>
                </div>
              </div>
              <div className="flex flex-col text-h3 gap-10 w-full  flex-grow max-h-full  overflow-y-auto pr-10 pb-10">
                {messages.map((message, index) => (
                  <div
                    ref={index === messages?.length - 1 ? div_ref : null} // Attach ref to last message
                    key={index}
                    className="w-full flex flex-row justify-end "
                  >
                    {message.sender === "user" && (
                      <div className="flex flex-row   max-w-c700">
                        <div
                          className={`text-black  bg-white py-2 px-4 rounded-3xl `}
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {message.message}
                        </div>{" "}
                      </div>
                    )}
                    {message.sender === "ai" && (
                      <div className="flex flex-row w-full justify-start items-start gap-3">
                        {" "}
                        <Icon1 icon_name="ai" size={20} fill="lightgrey" />
                        <div className="flex flex-col">
                          <div
                            className={`text-shadow_50  max-w-c700`}
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {message.message}
                          </div>{" "}
                          {message.tablesData &&
                            Object.keys(message.tablesData).length > 0 && (
                              <div className="text-h3 text-shadow_50">
                                Nombre de tableaux :{" "}
                                {Object.keys(message.tablesData).length}
                              </div>
                            )}
                          <div className="flex flex-col ">
                            {message.tablesData &&
                              Object.keys(message.tablesData).map(
                                (key, index) => (
                                  <div
                                    key={index}
                                    className="flex flex-col gap-1"
                                  >
                                    <div className="text-h3 text-shadow_50 mt-4 font-semibold">
                                      Tableau {index + 1}
                                    </div>
                                    {buildTable(message.tablesData[key])}
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}{" "}
                {loading_ai && (
                  <div className="flex flex-row w-full items-center  gap-3 mt-4">
                    <Icon1 icon_name="ai" size={20} fill="grey" />
                    <div className="text-shadow_50 font-medium">
                      En train de réfléchir
                    </div>

                    <SmallSpinner />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="absolute bottom-5 flex flex-grow flex-col justify-end p-4 min-h-fit h-fit">
            <div className=" text-h3 text-shadow_25 shadow-md bg-white rounded-xl px-6 py-4 max-w-full w-c700">
              <MLTFGPT1
                value={value}
                onChange={(e) => setValue(e.target.value)}
                label={"Posez votre question ..."}
                auto_scale={true}
                rows={3}
                refreshRows={refreshRows}
              ></MLTFGPT1>
              {value !== "" && (
                <div className="flex flex-row justify-end w-full gap-2 mt-2">
                  <SecondaryButton
                    className="w-fit"
                    onClick={() => {
                      setMessages([]);
                      setValue("");
                    }}
                  >
                    Effacer toute la conversation
                  </SecondaryButton>
                  <SecondaryButton
                    className="w-fit"
                    onClick={() => setValue("")}
                  >
                    Effacer
                  </SecondaryButton>
                  <PrimaryButton onClick={handleSendRequest} className="w-fit">
                    Envoyer
                  </PrimaryButton>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Assistant;

export const getFirstNameFormFullName = (fullName) => {
  return fullName.split(" ")[0];
};

const buildTable = (data) => {
  if (!data || data?.length === 0) return <p>No data available</p>;

  const headers = Object.keys(data[0]); // Extract column headers dynamically

  return (
    <table className="border-1 mt-4 w-fit">
      <thead>
        <tr>
          {headers
            .sort((a, b) => a.localeCompare(b))
            .map((header) => (
              <th
                className="border-1 border-shadow_10 bg-shadow_5 px-4 w-fit"
                key={header}
              >
                {header}
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {headers
              .sort((a, b) => a.localeCompare(b))
              .map((header) => (
                <td
                  className="border-1 border-shadow_10 px-4 w-fit"
                  key={header}
                >
                  {row[header]}
                </td>
              ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const parseMarkdownTable = (markdown) => {
  const lines = markdown.trim().split("\n");

  if (!lines) return [];

  if (lines.length < 3) {
    console.error("Invalid Markdown table format");
    return [];
  }

  const headers = lines[0]
    .split("|")
    .map((h) => h.trim())
    .filter(Boolean);
  const rows = lines.slice(2).map((line) =>
    line
      .split("|")
      .map((cell) => cell.trim())
      .filter(Boolean)
  );

  return rows.map((row) => {
    return headers.reduce((acc, header, index) => {
      acc[header] = isNaN(row[index]) ? row[index] : Number(row[index]);
      return acc;
    }, {});
  });
};

const extractMarkdownTables = (text) => {
  const tableRegex = /\n(\|.+\|\n)(\|[-\s|]+\|\n)((\|.+\|\n?)+)/g;
  let tables = [];
  let match;

  // Extract all tables
  while ((match = tableRegex.exec(text)) !== null) {
    tables.push(match[0].trim());
  }

  // Remove all extracted tables from the text
  let textWithoutTables = text.replace(tableRegex, "").trim();

  if (tables.length === 0) {
    console.warn("No Markdown table found in the text.");
    return { tables: null, textWithoutTables: text };
  }

  return { tables, textWithoutTables };
};
